import { Component, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BannerAppComponent } from '../../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../../components/footer-app/footer-app.component';
import { DataLayerService } from '../../../../services/DataLayer/data-layer.service';
import { InactivityService } from '../../../../services/inactivity/inactivity.service';
import { DetailsVehicleBannerComponent } from '../../../components/details-vehicle-banner/details-vehicle-banner.component';
import { FinancedVehicleComponent } from '../../components/financied-vehicle/financed-vehicle.component';

@Component({
  selector: 'app-onerous-financed-page',
  templateUrl: './onerous-financed-page.component.html',
  styleUrl: './onerous-financed-page.component.scss',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    BannerAppComponent,
    DetailsVehicleBannerComponent,
    FinancedVehicleComponent,
    FooterAppComponent,
  ],
})
export class OnerousFinancedPageComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);
  private dataLayerService = inject(DataLayerService);
  inactivityService = inject(InactivityService);

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'onerosos');
    this.inactivityService.stopTimer();
    this.inactivityService.startDefaultTimerForScreen('Seleccion-Bancos', 'Abandono Prenda', '40');
    this.dataLayerService.pushDataLayerOnerous(
      'Pageview',
      'moto_ecommerce_step_2.3_Prenda',
      'Prenda',
    );
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'onerosos');
    this.inactivityService.stopTimer();
  }
}
